

import React from "react";
function Footer() {
    return (
        <div className="" style={{  }}>
            <footer>
                <p>&copy; Copyright © 2026 HCLTech | Confidential</p>
            </footer>
        </div>
    );
}

export default Footer;
